import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid2,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import RewardCalculatorImg from "Assets/Images/RewardCalculator.png";
import RewardsCalculatorSection from "./RewardsCalculatorSection";

const RewardCalculator = ({ open, setOpen }) => {
  const handleClose = () => {
    setOpen(false);
  };

  const { ReferralReward, Translation } = useSelector((state) => ({
    ReferralReward: state.ReferralReward.referralReward,
    Translation: state.Translation.translation?.Referral || {},
  }));

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={() => handleClose()}>
      <DialogTitle>
        {Translation?.ReferralRewardsCalculator}{" "}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "24px" }}
      >
        <Grid2 container spacing={3} alignItems={"center"}>
          <Grid2 size={5}>
            <img
              style={{ maxWidth: "330px" }}
              src={RewardCalculatorImg}
              alt="Referral Rewards Calculator"
            />
          </Grid2>
          <Grid2
            size={7}
            display={"flex"}
            flexDirection={"column"}
            gap={"16px"}
            alignItems={"start"}
          >
            <Typography variant="title" fontWeight={500}>
              {Translation?.CodedReferralRewardCalculator}
            </Typography>
            <Button variant="contained" color="error">
              {Translation?.StartReferringNow}
            </Button>
            <Typography color="secondary.light">
              {Translation?.ContactOnRegisteredNumber}
            </Typography>
          </Grid2>
        </Grid2>
        <RewardsCalculatorSection from="dialog" />
      </DialogContent>
    </Dialog>
  );
};

export default RewardCalculator;
